var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeading = function SvgHeading(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 2.625H17.125C17.4375 2.625 17.75 2.35156 17.75 2V1.375C17.75 1.0625 17.4375 0.75 17.125 0.75H12.125C11.7734 0.75 11.5 1.0625 11.5 1.375V2C11.5 2.35156 11.7734 2.625 12.125 2.625H13.375V8.5625H4.625V2.625H5.875C6.1875 2.625 6.5 2.35156 6.5 2V1.375C6.5 1.0625 6.1875 0.75 5.875 0.75H0.875C0.523438 0.75 0.25 1.0625 0.25 1.375V2C0.25 2.35156 0.523438 2.625 0.875 2.625H2.125V16.375H0.875C0.523438 16.375 0.25 16.6875 0.25 17V17.625C0.25 17.9766 0.523438 18.25 0.875 18.25H5.875C6.1875 18.25 6.5 17.9766 6.5 17.625V17C6.5 16.6875 6.1875 16.375 5.875 16.375H4.625V10.4375H13.375V16.375H12.125C11.7734 16.375 11.5 16.6875 11.5 17V17.625C11.5 17.9766 11.7734 18.25 12.125 18.25H17.125C17.4375 18.25 17.75 17.9766 17.75 17.625V17C17.75 16.6875 17.4375 16.375 17.125 16.375H15.875V2.625Z",
    fill: "#DBE3EB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heading.cf24f3c0.svg";
export { ForwardRef as ReactComponent };